import { Box } from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { ParagraphText, UBButton, UBOTPInput } from "../../../Libraries";
import { HeaderRupin } from "../../common";
import {
  ArrowIcon,
  PhoneIcon,
  SMSIcon,
  Whatsapp,
} from "../../../assets/icons/icon";
import { sendOTP, Sync } from "../../../SyncService";
import { useSnackbar } from "../../../context/SnackbarContext";
import Cookies from "js-cookie";
import { useAuthContext } from "../../../context/AuthContext";
import BusinessLoader from "../../common/BusinessLoader";
import { useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useWalletContext } from "../../../context/WalletContext";
import { handleApi } from "../../../apis";
import { POST_LOGIN } from "../../../apis/configuration";
import FooterRupin from "../../common/FooterRupin";
import styles from "./styles.module.css";
import { sentenceCase } from "../../../constants";
const VerifyOTP = ({
  phone,
  handleVerifyOTP,
  setOTP,
  userId,
  isSignup,
  sendOTPResponse,
  backToLogin,
  isShowRightCta = true,
  handleLockedAccount = () => {},
}) => {
  const navigate = useNavigate();
  const [I18n] = useContext(LanguageContext);
  const { showSnackbar } = useSnackbar();
  const { user, setUser } = useAuthContext();
  const { setWalletData } = useWalletContext();
  const [loading, setLoading] = useState(false);

  let initialState = {
    sms: false,
    call: false,
    whatsapp: false,
  };

  const [resendLoading, setResendLoading] = useState(initialState);
  const [OTPVerifyloading, setOTPVerifyLoading] = useState(false);
  const OTPOPTION = {
    voice: { name: "voice", icon: <PhoneIcon />, label: I18n.phone_number },
    sms: { name: "sms", icon: <SMSIcon />, label: I18n.phone_sms },
    whatsapp: {
      name: "whatsapp",
      icon: <Whatsapp width={16} height={16} />,
      label: I18n.whatsapp_number,
    },
  };
  const [value, setValue] = useState("");
  const [seconds, setSeconds] = useState(30); // Initialize countdown at 30 seconds
  const [isHideOTPSentBtn, setIsHideOTPSentBtn] = useState(true);
  const [otpOption, setOtpOption] = useState(
    OTPOPTION[
      sendOTPResponse?.otp_channel === "call"
        ? "voice"
        : sendOTPResponse?.otp_channel
    ]?.name,
  );
  const [error, setError] = useState("");

  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000); // Update every second

      return () => clearInterval(interval); // Clear interval when component unmounts or timer reaches 0
    } else {
      setIsHideOTPSentBtn(false); // Enable button again once timer finishes
    }
  }, [seconds]);

  const resendOTP = async (option, method) => {
    setResendLoading((prev) => ({
      ...prev,
      [method]: true,
    }));

    setValue("");
    try {
      let params = {
        phone_number: phone,
        version: "multi-business",
        onboarding_type: isSignup ? "signup" : "login",
        otp_channel: option !== OTPOPTION.whatsapp.name ? option : undefined,
      };
      setOtpOption(option);
      await sendOTP(params);
      triggerLogEvent(
        analytics,
        `login_otp_resend_${option == "voice" ? "call" : option}`,
      );
      setSeconds(30); // Reset the countdown to 30 seconds
      setIsHideOTPSentBtn(true); // Disable the button until the timer is finished
      setValue("");
      setResendLoading(initialState);
      setError("");
    } catch (error) {
      if (error?.response?.data?.account_status === "suspended") {
        handleLockedAccount(true);
        return;
      }
      if (error?.response?.data?.message)
        setError(error?.response?.data?.message);
      setSeconds(0); // Reset the countdown to 30 seconds
      setIsHideOTPSentBtn(false); // Disable the button until the timer is finished
      setValue("");
      setResendLoading(initialState);
    }
  };

  const submitVerifyOTP = async (otp) => {
    setValue(otp);
    if (value.length == 0 && otp.length >= 1)
      triggerLogEvent(analytics, "login_otp_enter");
    if (otp.length === 4) {
      try {
        setError("");
        setOTPVerifyLoading(true);
        const response = await handleApi(
          POST_LOGIN,
          {
            phone_number: phone,
            otp,
            user_id: userId || undefined,
          },
          null,
          navigate,
          { "Web-Token": Cookies.get("deviceId") },
        );
        if (response?.otp_expired || !response?.success) {
          setOTPVerifyLoading(false);
          setError(response?.message);
          setValue("");
          setSeconds(0); // Reset the countdown to 30 seconds
          setIsHideOTPSentBtn(false); // Disable the button until the timer is finished
          return;
        }
        if (response?.success) {
          setOTP(otp);
          setOTPVerifyLoading(false);
          handleVerifyOTP(response);
          setWalletData();
          showSnackbar({
            message: I18n.otp_verified_successfully,
            severity: "success",
            icon: "",
            toastId: "verifyOTPSuccess",
          });
          triggerLogEvent(analytics, "login_otp_verified");
        }
      } catch (error) {
        setOTPVerifyLoading(false);
        setError(error.response.data.message || "Error in OTP verify");
        setValue("");
        setSeconds(0); // Reset the countdown to 30 seconds
        setIsHideOTPSentBtn(false); // Disable the button until the timer is finished
      }
    }
  };

  const resendOTPOptions = sendOTPResponse?.resend_otp_options || [];
  const openWhatsApp = () => {
    triggerLogEvent(analytics, "verify_otp_help");
    window.open(
      "https://api.whatsapp.com/send/?phone=%2B923420191000&text&type=phone_number&app_absent=0",
      "_blank",
    );
  };
  return (
    <Box className={`${styles.verifyOTPWrapper} onBoardingScreenWrapper`}>
      <BusinessLoader loadBusiness={OTPVerifyloading || loading} />
      {!OTPVerifyloading && !loading && (
        <Fragment>
          <Box className="verifyOTPHeader">
            <HeaderRupin>
              {isShowRightCta && (
                <ParagraphText
                  className={styles.AccountRightSection}
                  onClick={() => {
                    triggerLogEvent(analytics, "login_back_to_login");
                    backToLogin();
                  }}
                >
                  {I18n.change_phone_number} <ArrowIcon />
                </ParagraphText>
              )}
            </HeaderRupin>
          </Box>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
            height={"calc(100% - 72px)"}
            className={styles.verifyOTPCenter}
          >
            <Box className={styles.verifyOTPInner}>
              <ParagraphText className={"fontSize24 fontWeight500 newFontColor"}>
                {sentenceCase(`${I18n.verify} ${I18n.phone_number}`)}
              </ParagraphText>
              <Box mb={"10px"} />
              <ParagraphText
                className={`fontSize14 newLightColor ${styles.optionStyle}`}
              >
                <Box display={"flex"} alignItems={"center"} className={styles.otpSentToRow}>
                  {otpOption === OTPOPTION.voice.name
                    ? I18n.we_will_call_for_OTP_to_your
                    : I18n.otp_code_sent}{" "}
                  <span
                    className={styles.otpSentToLabel}
                    style={{
                      display: "inline-flex",
                      marginLeft: "5px",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        marginRight: "2px",
                      }}
                    >
                      {OTPOPTION[otpOption]?.icon}
                    </span>
                    {OTPOPTION[otpOption]?.label}
                  </span>
                </Box>
                {phone || ""}
              </ParagraphText>
              <Box marginBottom={2} />
              <UBOTPInput
                label={I18n.enter_otp_code}
                id="verify_otp"
                className="marginTop40"
                placeholder="****"
                value={value}
                onChangeQuery={submitVerifyOTP}
                shouldAutoFocus={true}
                invalid={!!error}
                helperText={error}
              />
              <Box marginBottom={"34px"} />
              {isHideOTPSentBtn ? (
                <Box display={"flex"} alignItems={"center"} gap={1}>
                  <ParagraphText className={"fontSize14  newLightColor"}>
                    {I18n.resend_code_in}{" "}
                    <span className="marginLeft5">{`00:${String(seconds).padStart(2, "0")}`}</span>
                  </ParagraphText>
                </Box>
              ) : (
                <Box>
                  <ParagraphText className={"fontSize14 newFontColor"}>
                    {I18n.Select_the_options_below_to_receive_a_new_OTP}
                  </ParagraphText>
                  <Box className={styles.VerifyOTPResetBtn}>
                    {resendOTPOptions.includes("sms") && (
                      <UBButton
                        id="opt_sms_btn"
                        disabled={resendLoading.sms}
                        iconComponent={<SMSIcon />}
                        className={`ubSecondaryButton ${styles.resendButton}`}
                        title={I18n.sms}
                        loading={resendLoading.sms}
                        onClick={() => {
                          triggerLogEvent(analytics, "login_otp_resend", {
                            method: "sms",
                          });
                          resendOTP(OTPOPTION.sms.name, "sms");
                        }}
                      />
                    )}
                    {resendOTPOptions.includes("call") && (
                      <UBButton
                        id="opt_call_btn"
                        disabled={resendLoading.call}
                        iconComponent={<PhoneIcon width={18} height={18} />}
                        className={`ubSecondaryButton ${styles.resendButton}`}
                        title={I18n.call}
                        loading={resendLoading.call}
                        onClick={() => {
                          triggerLogEvent(analytics, "login_otp_resend", {
                            method: "voice",
                          });
                          resendOTP(OTPOPTION.voice.name, "call");
                        }}
                      />
                    )}
                    {resendOTPOptions.includes("whatsapp") && (
                      <UBButton
                        id="opt_whatsapp_btn"
                        disabled={resendLoading.whatsapp}
                        iconComponent={<Whatsapp />}
                        className={`ubSecondaryButton ${styles.resendButton}`}
                        title={I18n.whatsapp}
                        loading={resendLoading.whatsapp}
                        onClick={() => {
                          triggerLogEvent(analytics, "login_otp_resend", {
                            method: "whatsapp",
                          });
                          resendOTP(OTPOPTION.whatsapp.name, "whatsapp");
                        }}
                      />
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
          <Box className="verifyOTPFooter">
            <FooterRupin />
          </Box>
        </Fragment>
      )}
    </Box>
  );
};
export default VerifyOTP;
